import React, { useEffect, useState } from 'react';

interface ColorPickerProps {
  label: string;
  colorHex: string;
  onColorChange: (colorHex: string) => void;
}

const ColorPicker: React.FC<ColorPickerProps> = ({ label, colorHex, onColorChange }) => {
  const [color, setColor] = useState(colorHex || '');

  useEffect(() => {
    setColor(colorHex);
  }, [colorHex]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newColor = event.target.value;
    setColor(newColor);
    onColorChange(newColor);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div style={{ marginRight: '10px', fontWeight: 'bold' }}>
        {label}
      </div>
      <input
        type="color"
        value={color}
        onChange={handleChange}
        style={{ marginRight: '10px' }}
        list="colors"
        className="form-control form-control-color"
      />
      <input
        className="form-control mb-1"
        type="text"
        value={color}
        onChange={handleChange}
        style={{ width: 100 }}
      />
    </div>
  );
};

export default ColorPicker;
